"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineHeaderForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../../dsl/backoffice");
const services_1 = require("../../../services");
const _contracts_1 = require("../../_contracts");
/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let LineHeaderForm = class LineHeaderForm extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.DashmixIconName = backoffice_1.DashmixIconName;
        this.canHaveHeaderImage = !!this.image;
    }
    mounted() {
        if (Object.prototype.hasOwnProperty.call(this._header, 'bold')) {
            this.$nextTick(() => {
                this._header = {
                    ...this._header,
                    isLink: this._header.bold
                };
            });
        }
        this.canHaveHeaderImage = !!this.image;
    }
    get canHaveHeaderLink() {
        if (!this._header || !this._showHeader || !this._header.isLink) {
            return false;
        }
        return this._header.isLink;
    }
    get hasHeaderLink() {
        if (!this.link) {
            return false;
        }
        return services_1.isRelated(this.link);
    }
    /**
     * Function to find image source
     */
    findImageSource() {
        this.pickRelated(services_1.Picker.Media, this.setImageSource);
    }
    /**
     * Function to check if background image is selected.
     */
    hasImage() {
        return !!this.image && typeof this.image.value !== 'undefined';
    }
    /**
     * Function to remove background image
     */
    removeImage() {
        this.image = null;
    }
    /**
     * Function to set background image source
     */
    setImageSource(source) {
        this.image = source;
        this.$emit('findImageSource', source);
    }
    /**
     * TODO: Description.
     */
    get siteOptions() {
        return [
            { label: `${this.$t('forms.shared.site.none')}`, value: '' },
            ...Object.entries(_contracts_1.Site).map(([key, value]) => {
                return {
                    label: key,
                    value: value
                };
            })
        ];
    }
    findHeaderLinkSource() {
        this.pickRelated(services_1.Picker.Content, (source) => this.setHeaderLinkSource(source));
    }
    onHeaderIsLinkChange(value) {
        if (!this._header) {
            return;
        }
        this._header = {
            ...this._header,
            isLink: value
        };
        if (!value) {
            this.link = null;
        }
    }
    onHeaderIsImageChange(value) {
        if (!this._header) {
            return;
        }
        this.canHaveHeaderImage = value;
        if (!value) {
            this.image = null;
        }
    }
    onHeaderIsH1Change(value) {
        if (!this._header) {
            return;
        }
        this._header = {
            ...this._header,
            isH1: value
        };
    }
    onShowHeaderChange(value) {
        this._showHeader = value;
        if (!value) {
            this.link = null;
        }
    }
    setHeaderLinkSource(source) {
        this.link = source;
        this.$emit('findLinkSource', source);
    }
};
__decorate([
    vue_property_decorator_1.PropSync('header', { type: Object, required: false, default: () => { return {}; } }),
    __metadata("design:type", Object)
], LineHeaderForm.prototype, "_header", void 0);
__decorate([
    vue_property_decorator_1.PropSync('showHeader', { type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LineHeaderForm.prototype, "_showHeader", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false }),
    __metadata("design:type", Boolean)
], LineHeaderForm.prototype, "canBeImage", void 0);
__decorate([
    vue_property_decorator_1.PropSync('headerLink', { type: Object, required: false, default: null }),
    __metadata("design:type", Object)
], LineHeaderForm.prototype, "link", void 0);
__decorate([
    vue_property_decorator_1.PropSync('headerImage', { type: Object, required: false, default: null }),
    __metadata("design:type", Object)
], LineHeaderForm.prototype, "image", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false }),
    __metadata("design:type", String)
], LineHeaderForm.prototype, "linkDescription", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false }),
    __metadata("design:type", String)
], LineHeaderForm.prototype, "imageDescription", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Function, required: true }),
    __metadata("design:type", Function)
], LineHeaderForm.prototype, "pickRelated", void 0);
LineHeaderForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'LineHeaderForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixFile: backoffice_1.DashmixFile,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixSelect: backoffice_1.DashmixSelect
        },
        template: `
    <div>
      <div class="row">
        <!-- Heading text -->
        <div class="form-group col-12 col-md-6">
          <label for="header">{{ $t('forms.shared.moduleHeader') }}<span class="text-danger">*</span></label>
          <DashmixInput :model.sync="_header.text"
                        :placeholder="$t('forms.shared.headerPlaceholder')"
                        name="header" :disabled="!_showHeader"  />

          <DashmixCheck class="pt-2" :label="$t('forms.shared.showModuleHeader')" name="showHeading"
                        :model="_showHeader" @update:model="onShowHeaderChange" />

          <DashmixCheck :label="$t('forms.shared.linkHeader')" name="isLink"
                        :model="_header.isLink" @update:model="onHeaderIsLinkChange" />

          <DashmixCheck v-if="canBeImage" :label="$t('forms.shared.imageHeader')" name="isImage"
                        :model="canHaveHeaderImage" @update:model="onHeaderIsImageChange" />

          <DashmixCheck :label="$t('forms.shared.h1Header')" name="isH1"
                        :model="_header.isH1" @update:model="onHeaderIsH1Change" />
        </div>

        <!-- Heading site -->
        <div class="form-group col-12 col-md-6">
          <label for="header">{{ $t('forms.shared.SelectIcon') }}</label>
          <DashmixSelect name="headerSite" :model.sync="_header.site"
                         :placeholder="$t('forms.shared.iconPlaceholder')"
                         :options="siteOptions" :searchable="false" :disabled="!_showHeader" />
        </div>

        <!-- Link of header-->
        <div class="form-group col-12 col-md-12" v-if="canHaveHeaderLink">
          <p class="m-0"><b v-html="$t('forms.shared.headerLink')"></b></p>
          <div class="row">
            <template v-if="hasHeaderLink">
              <div class="col d-flex align-items-center">
                <p class="mb-0">
                  <strong class="mr-2">{{ $t('forms.shared.chosenSource') }}</strong>
                  {{ linkDescription }}
                </p>
              </div>
              <div class="col-3 text-right">
                <DashmixButton variant="alt" :icon="DashmixIconName.PenSolid" :label="$t('forms.shared.change')"
                               @click="() => findHeaderLinkSource()"/>
              </div>
            </template>
            <template v-else>
              <div class="form-group col-12 col-md-6 mt-4" v-if="_header.isLink">
                <DashmixButton variant="alt" :icon="DashmixIconName.PenSolid" :label="$t('forms.shared.add')"
                               @click="() => findHeaderLinkSource()"/>
              </div>
            </template>
          </div>
        </div>

        <div class="form-group col-12 col-md-12" v-if="canHaveHeaderImage">
          <!-- Image -->
          <label for="background" class="d-block">{{ $t('forms.about.image.label') }}</label>
          <div class="row" v-if="hasImage()">
            <div class="col d-flex align-items-center">
              <figure class="figure-with-btn__image-container mt-4">
                <DashmixFile class="teaser-box__header__image" :file="{ thumbnail: imageDescription, type: 'jpg' }" />

                <DashmixButton class="figure-with-btn__delete-btn"
                               size="small" variant="icon" :icon="DashmixIconName.TrashSolid" theme="danger"
                               @click="removeImage" />
              </figure>
            </div>
            <div class="col-3 text-right">
              <DashmixButton variant="alt" :class="{'mb-4': !hasImage() }"
                             :icon="DashmixIconName.SearchSolid"
                             :label="$t('forms.shared.change')"
                             @click="findImageSource" />
            </div>
          </div>
          <DashmixButton v-else variant="alt" :class="{'mb-4': !hasImage() }"
                         :icon="DashmixIconName.SearchSolid"
                         :label="$t('forms.shared.add')"
                         @click="findImageSource" />
          <!-- Image || END -->
        </div>
      </div>
    </div>
  `
    })
], LineHeaderForm);
exports.LineHeaderForm = LineHeaderForm;
//# sourceMappingURL=LineHeader.form.js.map